import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`As you capture more `}<inlineCode parentName="p">{`cta clicked`}</inlineCode>{` events, more exposures will populate the primary metrics in your experiment. `}</p>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/experiment_metrics_ecea40f310.png" imageDark="https://res.cloudinary.com/dmukukwp6/image/upload/experiment_metrics_dark_6fed5063b9.png" alt="Evaluate experiment metrics" classes="rounded" mdxType="ProductScreenshot" />
    <p>{`With enough data, you can analyze the experiment and its variants by: `}</p>
    <ul>
      <li parentName="ul">{`Conversion rates`}</li>
      <li parentName="ul">{`Statistical significance`}</li>
      <li parentName="ul">{`Credible intervals`}</li>
      <li parentName="ul">{`Chance to win %`}</li>
      <li parentName="ul">{`Minimum detectable effect`}</li>
      <li parentName="ul">{`And more`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      